import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongChongipryukryul = () => {

    const today = new Date();
    const currentYear = today.getFullYear();

    const [searchParams, setSearchParams] = useState({
        searchYear: new Date().getFullYear(),
        searchCheck1: "",
        searchGrdc: '',
        searchLoca: '',
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? "1" : "") : value
        };
        setSearchParams(newParams);
    };

    const dataHead = [['의료기관명', '종별', '1월', '1월', '2월', '2월', '3월', '3월', '4월', '4월', '5월', '5월', '6월', '6월', '7월', '7월', '8월', '8월', '9월', '9월', '10월', '10월', '11월', '11월', '12월', '12월'],
    ['의료기관명', '종별', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력', '총계', '입력']];
    const dataColumn = ['TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9', 'TT10', 'TT11', 'TT12', 'TT13', 'TT14', 'TT15', 'TT16', 'TT17', 'TT18', 'TT19', 'TT20', 'TT21', 'TT22', 'TT23', 'TT24', 'TT25', 'TT26'];
    const apiCall = '/ptmiapi/monitoring/bdtongchongipryukryul_search.do';
    const apiCntCall = '';
    const excelFileName = "총 입력률";
    const excelHead = ['의료기관명', '종별', '1월 [총계]', '1월 [입력]', '2월 [총계]', '2월 [입력]', '3월 [총계]', '3월 [입력]', '4월 [총계]', '4월 [입력]', '5월 [총계]', '5월 [입력]', '6월 [총계]', '6월 [입력]', '7월 [총계]', '7월 [입력]', '8월 [총계]', '8월 [입력]', '9월 [총계]', '9월 [입력]', '10월[총계]', '10월[입력]', '11월[총계]', '11월[입력]', '12월[총계]', '12월[입력]'];
    const mergeConfig = [{ key: 'TT1', row: null }, { key: 'TT2', row: 2, nullable: 'true' }]

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                            <th>기간</th>
                            <td colSpan='3'>
                                <select
                                    id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 11 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <div>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                rowspan={2}
                mergeConfig={mergeConfig}
            />
        </Main>
    )
}

export default BdTongChongipryukryul;